/**
 * A program name short enough to sit in a badge on a roster row.
 *
 * BHCS names programs for the finance system — "FY26-FY27 Mini TK Program", "Regular G1-G5
 * Afterschool 2026-2027" — and every one of those names carries the same fiscal year and
 * the same word "afterschool". On a merged roster the badge exists to answer one question,
 * *which* of these four a child is in, so everything the four have in common is noise that
 * pushes the answer off the end of a phone screen.
 *
 * Only leading fiscal years and trailing boilerplate are removed; the distinguishing middle
 * of the name is never touched, and a name that is nothing but boilerplate is left alone
 * rather than shortened to nothing.
 */

/** Fiscal-year prefix, e.g. "FY26-FY27 ". */
const FISCAL_PREFIX_RE = /^FY\d{2}\s*-\s*FY\d{2}\s+/i;

/**
 * Trailing fragments that say nothing once you are looking at a list of this school's
 * programs. Applied repeatedly, so "Afterschool 2026-2027" sheds both halves.
 */
const TRAILING_NOISE_RE =
  /(?:\s+\d{4}\s*[-–]\s*\d{4}|\s*\((?:fall|spring|summer|winter)\s*\d{4}\)|\s+after\s*[-\s]?school|\s+program|\s*[-–—:·]+)$/i;

export function shortProgramLabel(name: string): string {
  const full = name.trim().replace(/\s+/g, ' ');
  let short = full.replace(FISCAL_PREFIX_RE, '').trim();

  let previous: string;
  do {
    previous = short;
    short = short.replace(TRAILING_NOISE_RE, '').trim();
  } while (short !== previous);

  return short.length > 0 ? short : full;
}
